import { Component, OnInit } from '@angular/core';
import { IMultiSelectSettings, IMultiSelectTexts, IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { UploadService } from '../upload/upload.service';
import { ProfileService, InvoiceData, ProfileData, PasswordData, EmailData, NotificationsData } from './profile.service';
import { FormErrors } from '../login/auth.service';

import { ToastyService, ToastOptions } from 'ng2-toasty';
import { AuthService } from '../login/auth.service';



@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    providers: [UploadService, ProfileService]
})

export class ProfilePage implements OnInit {
    public months: Array<any> = [];
    public years: Array<any> = [];

    public mySettings: IMultiSelectSettings = {
        enableSearch: false,
        checkedStyle: 'fontawesome',
        buttonClasses: 'btn btn-default btn-block multiple-dropdown',
        dynamicTitleMaxItems: 1,
        displayAllSelectedText: false,
        fixedTitle: false,
        selectionLimit: 1,
        closeOnSelect: true,
        autoUnselect: true,
    }

    public invoiceStatus: number = 0;
    public invoiceStatuses = {
        none: 1,
        pending: 2,
        rejected: 3,
        approved: 4
    };
    public countries: Array<any> = [];

    public invoiceForm: InvoiceForm = new InvoiceForm;

    public profileForm: ProfileForm = new ProfileForm;
    public passwordForm: PasswordForm = new PasswordForm;
    public emailForm: EmailForm = new EmailForm;

    public notificationsForm: NotificationsData = new NotificationsData;

    public profileCountry: Array<number> = [];
    public profileCompanyCountry: Array<number> = [];

    constructor(public uploadService: UploadService, public profileService: ProfileService, private toastyService:ToastyService, public auth: AuthService) {
        this.uploadService.getInvoiceStatus().then(result => {
            this.invoiceStatus = result;
        });

        this.uploadService.taxes().then(result => {
            this.countries = result;
            this.countries.forEach(t => t.name = t.country);
        });


        this.profileService.getInvoiceData().then(result => {
            this.invoiceForm.data = result;
        });

        this.profileService.getProfile().then(result => {
            this.profileForm.data.companyName = result.companyName;
            this.profileForm.data.companyVat = result.companyVat;
            this.profileForm.data.companyAddress = result.companyAddress;
            this.profileForm.data.companyZip = result.companyZip;
            this.profileForm.data.companyCity = result.companyCity;
            this.profileForm.data.companyCountry = result.companyCountry;
            this.profileForm.data.firstName = result.firstName;
            this.profileForm.data.lastName = result.lastName;
            this.profileForm.data.address = result.address;
            this.profileForm.data.zip = result.zip;
            this.profileForm.data.city = result.city;
            this.profileForm.data.country = result.country;
            this.profileForm.data.email = result.email;

            this.profileCompanyCountry = result.companyCountry ? [result.companyCountry] : null;
            this.profileCountry = result.country ? [result.country] : null;

            this.notificationsForm.notifyAd = result.notifyAd;
            this.notificationsForm.notifyProfile = result.notifyProfile;
            this.notificationsForm.notifyNews = result.notifyNews;
        });

        let year = (new Date()).getFullYear();
        for (let d=0; d < 10; d++) {
            this.years.push({id: year+d, name: (year+d).toString().substr(-2)});
        }

        for (let m=1; m <= 12; m++) {
            this.months.push({id: m, name: this.padLeft(m.toString(), '0', 2)});
        }
    }

    private padLeft(text:string, padChar:string, size:number): string {
        return (String(padChar).repeat(size) + text).substr( (size * -1), size) ;
    }

    ngOnInit() {
        window.onbeforeunload = function (e) {
            // do nothing
            return
            }
    }

    public getCountryNameById(taxID: number) {
        let countries = this.countries.filter(t => t.id == taxID);
        if (countries.length) {
            return countries[0].country;
        }
        return "";
    }

    public onInvoiceFormSubmit() {
        if (this.invoiceForm.validate()) {
            this.profileService.updateInvoiceData(this.invoiceForm.data).then(result => {
                this.invoiceForm.active = false;
                this.invoiceStatus = this.invoiceStatuses.pending;

                this.profileForm.data.companyName = result.user.companyName;
                this.profileForm.data.companyVat = result.user.companyVat;
                this.profileForm.data.companyAddress = result.user.companyAddress;
                this.profileForm.data.companyZip = result.user.companyZip;
                this.profileForm.data.companyCity = result.user.companyCity;
                this.profileForm.data.companyCountry = result.user.companyCountry;
                this.profileForm.data.firstName = result.user.firstName;
                this.profileForm.data.lastName = result.user.lastName;
                this.profileForm.data.address = result.user.address;
                this.profileForm.data.zip = result.user.zip;
                this.profileForm.data.city = result.user.city;
                this.profileForm.data.country = result.user.country;

                this.profileCompanyCountry = result.user.companyCountry ? [result.user.companyCountry] : null;
                this.profileCountry = result.user.country ? [result.user.country] : null;

                let toastOptions:ToastOptions = {
                    title: null,
                    msg: "Invoice info updated successfully!",
                    showClose: true,
                    timeout: 5000,
                    theme: "bootstrap"
                };
                this.toastyService.success(toastOptions);
            }, err => {
                this.invoiceForm.errors.list = err.errors;
            });
        }
    }

    public onProfileFormSubmit() {
        if (this.profileForm.validate()) {
            this.profileService.updateProfileData(this.profileForm.data).then(result => {
                let toastOptions:ToastOptions = {
                        title: null,
                        msg: "Profile updated successfully!",
                        showClose: true,
                        timeout: 5000,
                        theme: "bootstrap"
                };
                this.toastyService.success(toastOptions);
            }, err => {
                this.profileForm.errors.list = err.errors;
            });
        }
    }

    public copyInvoiceFromProfile() {
            this.invoiceForm.data.companyName = this.profileForm.data.companyName;
            this.invoiceForm.data.companyVat = this.profileForm.data.companyVat;
            this.invoiceForm.data.companyAddress = this.profileForm.data.companyAddress;
            this.invoiceForm.data.companyZip = this.profileForm.data.companyZip;
            this.invoiceForm.data.companyCity = this.profileForm.data.companyCity;
            this.invoiceForm.data.companyCountry = this.profileForm.data.companyCountry;
    }

    public onPasswordFormSubmit() {
        if (this.passwordForm.validate()) {
            this.profileService.changePassword(this.passwordForm.data).then(
                result => {
                    this.passwordForm.hide();
                    let toastOptions:ToastOptions = {
                            title: null,
                            msg: "Password changed successfully!",
                            showClose: true,
                            timeout: 5000,
                            theme: "bootstrap"
                    };
                    this.toastyService.success(toastOptions);
                },
                err => {
                    let toastOptions:ToastOptions = {
                            title: null,
                            msg: "Please fill all necessary fields correctly!",
                            showClose: true,
                            timeout: 5000,
                            theme: "bootstrap"
                    };
                    this.toastyService.error(toastOptions);
                    this.passwordForm.errors.list = err.json().errors;
                }
            );
        }
    }

    public onEmailFormSubmit() {
        if (this.emailForm.validate()) {
            this.profileService.changeEmail(this.emailForm.data).then(
                result => {
                    this.emailForm.hide();
                    let toastOptions:ToastOptions = {
                            title: null,
                            msg: "Email change initiated! Check your mailbox for the confirmation email.",
                            showClose: true,
                            timeout: 5000,
                            theme: "bootstrap"
                    };
                    this.toastyService.success(toastOptions);
                },
                err => {
                    let toastOptions:ToastOptions = {
                            title: null,
                            msg: "Please fill all necessary fields correctly!",
                            showClose: true,
                            timeout: 5000,
                            theme: "bootstrap"
                    };
                    this.toastyService.error(toastOptions);
                    this.emailForm.errors.list = err.json().errors;
                }
            );
        }
    }

    public onNotificationsFormSubmit() {
        setTimeout( () => {
            this.profileService.updateNotifications(this.notificationsForm).then(
                result => {
                    let toastOptions:ToastOptions = {
                            title: null,
                            msg: "Notifications settings updated successfully!",
                            showClose: true,
                            timeout: 5000,
                            theme: "bootstrap"
                    };
                    this.toastyService.success(toastOptions);
                },
                err => {
                    let toastOptions:ToastOptions = {
                            title: null,
                            msg: "Some error occured. Try again later.",
                            showClose: true,
                            timeout: 5000,
                            theme: "bootstrap"
                    };
                    this.toastyService.error(toastOptions);
                }
            );
        }, 0);
    }

}


class ProfileForm {
    public data: ProfileData = new ProfileData;
    public notValid: boolean = true;
    public errors: FormErrors = new FormErrors;

    private isEmpty(str: string): boolean {
        return str.replace(/\s/g,'') == "";
    }

    public validate(): boolean {
        this.errors.clear();
        if (this.isEmpty(this.data.firstName)) {
            this.errors.add({field: 'firstName', type: 'required'});
        }
        if (this.isEmpty(this.data.lastName)) {
            this.errors.add({field: 'lastName', type: 'required'});
        }

        this.notValid = !this.errors.isEmpty();
        return !this.notValid;
    }
}

class PasswordForm {
    public data: PasswordData = new PasswordData;
    public newPassword2: string = "";
    public notValid: boolean = true;
    public errors: FormErrors = new FormErrors;
    public active: boolean = false;

    private isEmpty(str: string): boolean {
        return str.replace(/\s/g,'') == "";
    }

    public validate(): boolean {
        this.errors.clear();
        if (this.isEmpty(this.data.oldPassword)) {
            this.errors.add({field: 'oldPassword', type: 'required'});
        }
        if (this.isEmpty(this.data.newPassword)) {
            this.errors.add({field: 'newPassword', type: 'required'});
        }

        if (this.isEmpty(this.newPassword2)) {
            this.errors.add({field: 'newPassword2', type: 'required'});
        }
        if( !this.isEmpty(this.data.newPassword) && !this.isEmpty(this.newPassword2) && this.data.newPassword != this.newPassword2 ) {
            this.errors.add({field: 'newPassword2', type: 'match'});
        }

        this.notValid = !this.errors.isEmpty();
        return !this.notValid;
    }

    public show() {
        this.active = true;
    }

    public hide() {
        this.active = false;
        this.errors.clear();
        this.data = new PasswordData;
    }
}

class EmailForm {
    public data: EmailData = new EmailData;
    public notValid: boolean = true;
    public errors: FormErrors = new FormErrors;
    public active: boolean = false;

    private isEmpty(str: string): boolean {
        return str.replace(/\s/g,'') == "";
    }

    private isEmail(str: string): boolean {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(str);
    }

    public validate(): boolean {
        this.errors.clear();
        if (this.isEmpty(this.data.email)) {
            this.errors.add({field: 'email', type: 'required'});
        } else {
            if (!this.isEmail(this.data.email)) {
                this.errors.add({field: 'email', type: 'email'});
            }
        }
        this.notValid = !this.errors.isEmpty();
        return !this.notValid;
    }

    public show() {
        this.active = true;
    }

    public hide() {
        this.active = false;
        this.errors.clear();
        this.data = new EmailData;
    }
}

class InvoiceForm {
    public data: InvoiceData = new InvoiceData;
    public notValid: boolean = true;
    public errors: FormErrors = new FormErrors;
    public active: boolean = false;
    private oldData: any;

    private isEmpty(str: string): boolean {
        return str.replace(/\s/g,'') == "";
    }

    public validate(): boolean {
        this.errors.clear();

        if (this.isEmpty(this.data.companyName)) {
            this.errors.add({field: 'companyName', type: 'required'});
        }

        if (this.isEmpty(this.data.companyVat)) {
            this.errors.add({field: 'companyVat', type: 'required'});
        }

        if (this.isEmpty(this.data.companyAddress)) {
            this.errors.add({field: 'companyAddress', type: 'required'});
        }

        if (this.isEmpty(this.data.companyZip)) {
            this.errors.add({field: 'companyZip', type: 'required'});
        }

        if (this.isEmpty(this.data.companyCity)) {
            this.errors.add({field: 'companyCity', type: 'required'});
        }

        if (!this.data.companyCountry) {
            this.errors.add({field: 'companyCountry', type: 'required'});
        }

        this.notValid = !this.errors.isEmpty();
        return !this.notValid;
    }

    public edit() {
        this.errors.clear();
        this.active = true;
        this.oldData = Object.assign({}, this.data);
    }

    public cancel() {
        this.active = false;
        this.data = Object.assign({}, this.oldData);
    }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/profile/profile.component.ts